'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const components_navigation_IconButton_BaseIconButton = require('../IconButton/BaseIconButton.cjs.js');

const colorMappings = {
  "icon-primary": "icon-primary-dark",
  "icon-secondary": "icon-secondary-dark"
};
function DarkBackgroundIconButton(_a) {
  var { color = "icon-primary" } = _a, props = tslib_es6.__rest(_a, ["color"]);
  return react.jsx(components_navigation_IconButton_BaseIconButton.BaseIconButton, Object.assign({ color: colorMappings[color], size: "small" }, props));
}

exports.DarkBackgroundIconButton = DarkBackgroundIconButton;
//# sourceMappingURL=DarkBackgroundIconButton.cjs.js.map
